import React, { useEffect } from "react";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { VideoSection } from "./components/VideoSection";
import { BookSection } from "./components/BookSection";
import { AboutSection } from "./components/AboutSection";
import { PublishWithUs } from "./components/PublishWithUs";
import { Methodology } from "./components/Methodology";
import { FAQ } from "./components/FAQ";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { LandingSimple } from "./components/LandingSimple";
import { ReaderRegister } from "./components/ReaderRegister";
import { ReaderLogin } from "./components/ReaderLogin";
import { AutoLogin } from "./components/AutoLogin";
import { MyLibrary } from "./components/MyLibrary";
import { ReaderPage } from "./components/ReaderPage";
import { PaymentSuccess } from "./components/PaymentSuccess";
import { AdminPanel } from "./components/AdminPanel";
import { InstallAppBanner } from "./components/InstallAppBanner";
import { Toaster } from "./components/ui/sonner";

// Register Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => console.log('SW registered'))
      .catch(err => console.log('SW registration failed'));
  });
}

// Landing completa con todas las secciones (accesible en /home)
const HomePageFull = () => (
  <>
    <Header />
    <main>
      <Hero />
      <VideoSection />
      <BookSection />
      <AboutSection />
      <PublishWithUs />
      <Methodology />
      <FAQ />
      <ContactSection />
    </main>
    <Footer />
  </>
);

function App() {
  const location = useLocation();
  const showInstallBanner = location.pathname === '/reader';

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePageFull />} />
        <Route path="/paz-crecimiento" element={<LandingSimple />} />
        <Route path="/home" element={<HomePageFull />} />
        <Route path="/reader/register" element={<ReaderRegister />} />
        <Route path="/reader/login" element={<ReaderLogin />} />
        <Route path="/reader/auto-login" element={<AutoLogin />} />
        <Route path="/reader/biblioteca" element={<MyLibrary />} />
        <Route path="/reader" element={<ReaderPage />} />
        <Route path="/reader/success" element={<PaymentSuccess />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
      {showInstallBanner && <InstallAppBanner />}
      <Toaster />
    </div>
  );
}

export default App;